<template>
    <div>
        <h1 class="head-title">
            {{ generateHeadline() }}
        </h1>
        <div v-if="show_htoh_image" class="si-row" key="match-image">
          <div class="si-box si-gallery">
            <div class="si-content-wrp">
                <img
                  class="si-img"
                  loading="lazy"
                  :src="`${match_image}?w=${image_compression_width}`"
                  :title="generateMatchTitle()"
                  :alt="generateMatchTitle()"
                />
            </div>
          </div>
        </div>
        <no-list
            :translations="translations"
            :toShow="'no_feed'"
        />
    </div>
</template>

<script>
import NoList from "../../common/NoList";
import {mobilecheck, getMatch, getMatchImageTitle, getMatchInfoTitle} from "../../../assets/js/common";
export default {
  components: {
    NoList,
  },
  computed: {
    translations() {
      return this.$store.state.translations;
    },
    match_data() {
      return this.$store.state.match_detail_store.match_data;
    },
    slug() {
      return this.$store.state.match_detail_store.slug;
    },
    current_match() {
      return getMatch(this.match_data, "slug", this.slug) || {};
    },
    show_htoh_image() {
      return this.$store.state.fantasy_tips_store.show_htoh_image;
    },
    match_image() {
      let currMatch = this.current_match;
      let mImgUrl = 'https://www.fantasygully.com/static-assets/images/16_9_Match-Tips.png';
      if(currMatch && currMatch.code) {
        mImgUrl = `https://www.fantasygully.com/static-assets/images/v5_800/${currMatch.code}.jpg`;
      }
      return mImgUrl;
    },
    image_compression_width() {
      let {ismobile} = this.$store.state;
      let defaultW = '720';
      if (ismobile) {
        defaultW = '320';
      } else if (mobilecheck()) {
        defaultW = '320';
      }
      return defaultW;
    },
  },
  methods: {
    generateHeadline() {
      let isHindi = this.$route && this.$route.path && this.$route.path.includes("/hi/");
      return getMatchInfoTitle(this.current_match, this.translations.match_tips_headline, false, isHindi);
    },
    generateMatchTitle() {
      return getMatchImageTitle(this.current_match);
    },
  }
};
</script>